import { render } from "./Device.vue?vue&type=template&id=afe00ac2&scoped=true"
import script from "./Device.vue?vue&type=script&lang=js"
export * from "./Device.vue?vue&type=script&lang=js"

import "./Device.vue?vue&type=style&index=0&id=afe00ac2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afe00ac2"]])

export default __exports__